import type { InputOption } from "@/shared/types";
import { normalizeCountryLabel } from "@/shared/utils/country";

export const MAX_TRAVELLERS = 6;

export const OUTBOUND_UAE_COVERAGES = new Set([
  "Worldwide",
  "GCC Countries",
  "Schengen",
  "Hajj and Umrah",
]);

export const PLAN_TYPE_OPTIONS = [
  { label: "Single Trip", value: "single" },
  { label: "Annual Multi-Trip", value: "annual" },
] as const;

export const COVER_TYPE_OPTIONS = [
  { label: "Individual", value: "individual" },
  { label: "Group", value: "group" },
  { label: "Family", value: "family" },
] as const;

export function mapCountryOptions(data: unknown): InputOption<string>[] {
  return (Array.isArray(data) ? data : []).map((country: { value?: string; label?: string }) => ({
    value: normalizeCountryLabel(country.value),
    label: normalizeCountryLabel(country.label),
  }));
}

export function formatIsoDate(date: Date) {
  return date.toISOString().split("T")[0];
}

export function addDays(date: Date, days: number) {
  const nextDate = new Date(date);

  nextDate.setDate(nextDate.getDate() + days);

  return nextDate;
}
